import { BaseUserProfile } from 'fitbeat.models';
import React, { FunctionComponent } from 'react';
import {
  SafeAreaView, StyleSheet, TouchableOpacity, View,
} from 'react-native';
import FastImage from 'react-native-fast-image';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils';
import { IDeviceSetupProps } from '../DeviceSetup';
import { EquipmentInstruction } from '../EquipmentInstruction';
import { DeviceSetupContent } from './DeviceSetupContent';
import { DeviceSetupFooter } from './DeviceSetupFooter';
import { DeviceSetupHeader } from './DeviceSetupHeader';

const getImageInstructionWidth = (currentSequence: any): string => {
  if (currentSequence?.equipmentWeightInfo && currentSequence?.homeBenchInstructionImageUrl) {
    return '50%';
  }
  if (currentSequence?.equipmentWeightInfo || currentSequence?.homeBenchInstructionImageUrl) {
    return '50%';
  }
  return '';
};

export const DeviceSetupScreen: FunctionComponent<Partial<IDeviceSetupProps>> = (
  {
    userHasStartedWorkout,
    preloadingComplete,
    homeWorkoutVideoError,
    homeWorkoutLoading,
    isGroupWorkout,
    leaveWorkout,
    closeDeviceSetup,
    openSetupScreen,
    leaveWorkoutClicked,
    t,
    homeWorkoutLoadingError,
    resumeWorkoutPressed,
    mirrorIsActive,
    liveHeartRate,
    isLeaderboardActivated,
    localAudioIsMuted,
    localVideoIsMuted,
    toggleLocalAudio,
    toggleLocalVideoMuted,
    isGroupWorkoutCallConnected,
    disconnectGroupWorkoutCall,
    initiateGroupWorkoutCall,
    landscape = false,
    isGroupWorkoutCallConnecting,
    homeWorkoutSession,
    waitingToStartWorkout,
    remainingSecondsInSequence,
    groupWorkoutTalkingEnabled,
    isPastWarmdown,
    isStreamingWorkout,
    isStreamingWorkoutAndNotHost,
    customiseWorkoutSettingsDisabled,
    enableInstructorChange,
    currentSequence,
    shouldShowElements,
    userProfile,
    enableMirrorSetup,
  },
) => {
  const showBenchInstruction = !!currentSequence?.homeBenchInstructionImageUrl;
  const showEquipmentInstruction = !!currentSequence?.equipmentWeightInfo;
  const useAlphaFeatures = userProfile && BaseUserProfile.isFeatureEnabledForUser('alpha', userProfile) as boolean;

  return (
    <SafeAreaView style={landscape ? styleSheet.landscapeContainer : styleSheet.portraitContainer}>
      <View style={[landscape && { width: '50%', borderRightColor: Theme.GREY_DARK_MEDIUM, borderRightWidth: 1 }, {}]}>
        <DeviceSetupHeader
          openSetupScreen={openSetupScreen}
          mirrorIsActive={mirrorIsActive}
          enableMirrorSetup={enableMirrorSetup}
          isLeaderboardActivated={isLeaderboardActivated}
          isGroupWorkout={isGroupWorkout}
          liveHeartRate={liveHeartRate}
          landscape={landscape}
          t={t}
          customiseWorkoutSettingsDisabled={customiseWorkoutSettingsDisabled}
          enableInstructorChange={enableInstructorChange}
        />
        <DeviceSetupFooter
          openSetupScreen={openSetupScreen}
          isGroupWorkout={isGroupWorkout}
          localAudioIsMuted={localAudioIsMuted}
          localVideoIsMuted={localVideoIsMuted}
          toggleLocalAudio={toggleLocalAudio}
          toggleLocalVideoMuted={toggleLocalVideoMuted}
          isGroupWorkoutCallConnected={isGroupWorkoutCallConnected}
          isGroupWorkoutCallConnecting={isGroupWorkoutCallConnecting}
          disconnectGroupWorkoutCall={disconnectGroupWorkoutCall}
          initiateGroupWorkoutCall={initiateGroupWorkoutCall}
          landscape={landscape}
          homeWorkoutSession={homeWorkoutSession}
          waitingToStartWorkout={waitingToStartWorkout}
          groupWorkoutTalkingEnabled={groupWorkoutTalkingEnabled}
          remainingSecondsInSequence={remainingSecondsInSequence}
          preloadingComplete={preloadingComplete}
          isPastWarmdown={isPastWarmdown}
          t={t}
          isStreamingWorkoutAndNotHost={isStreamingWorkoutAndNotHost}
          isStreamingWorkout={isStreamingWorkout}
          shouldShowEliteInstructions={shouldShowElements?.shouldShowEliteInstructionsDuringPause}
        />
      </View>
      <View style={[landscape ? { width: '50%', flex: 1 } : { flex: 1 }, {}]}>
        {shouldShowElements?.shouldShowEliteInstructionsDuringPause
          && (
          <TouchableOpacity onPress={resumeWorkoutPressed} style={styleSheet.eliteInstructionContainer}>
            {showBenchInstruction && (
            <FastImage
              style={{
                width: getImageInstructionWidth(currentSequence),
                height: '100%',
              }}
              resizeMode='contain'
              source={{
                uri: currentSequence?.homeBenchInstructionImageUrl,
              }}
            />
            )}
            {showEquipmentInstruction && (
            <EquipmentInstruction
              containerStyle={{
                width:
                  getImageInstructionWidth(currentSequence),
              }}
              equipmentWeightInfo={currentSequence?.equipmentWeightInfo}
              useAlphaFeatures={useAlphaFeatures}
            />
            )}
          </TouchableOpacity>
          )}

        <DeviceSetupContent
          isGroupWorkout={isGroupWorkout}
          leaveWorkout={leaveWorkout}
          closeDeviceSetup={closeDeviceSetup}
          resumeWorkoutPressed={resumeWorkoutPressed}
          homeWorkoutLoading={homeWorkoutLoading}
          userHasStartedWorkout={userHasStartedWorkout}
          preloadingComplete={preloadingComplete}
          leaveWorkoutClicked={leaveWorkoutClicked}
          homeWorkoutLoadingError={homeWorkoutLoadingError}
          homeWorkoutVideoError={homeWorkoutVideoError}
          waitingToStartWorkout={waitingToStartWorkout}
          t={t}
          landscape={landscape}
          remainingSecondsInSequence={remainingSecondsInSequence}
          isPastWarmdown={isPastWarmdown}
          shouldShowEliteInstructions={shouldShowElements?.shouldShowEliteInstructionsDuringPause}
        />
      </View>
    </SafeAreaView>
  );
};

const styleSheet = StyleSheet.create({
  eliteInstructionContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    flex: 1,
    height: '100%',
    marginHorizontal: defaultScale(10),
  },
  landscapeContainer: {
    flexDirection: 'row',
    flex: 1,
  },
  portraitContainer: {
    flex: 1,
  },
});
